export default __webpack_public_path__ + "static/media/category5.6d1310bc.png";